import { defaultProps } from 'recompose';

import StatusIndicator from '../StatusIndicator';
import StatusLabel from '../StatusLabel';
import Status from './component';

export default defaultProps({
  StatusIndicator,
  StatusLabel,
})(Status);
